import React from "react";
import {
  FaCalendarAlt,
  FaEye,
  FaMapMarkerAlt,
  FaShareAlt,
  FaTrash,
} from "react-icons/fa";

import {
  formatDateFr,
  getEventLocation,
  getEventStatusLabel,
  getEventStatusStyle,
  getEventTitle,
  getEventType,
  getEventTypeStyle,
  isEventShared,
} from "../utils/adminEventsUtils";

function EventsMobileList({ events = [], onOpen, onDelete }) {
  return (
    <section className="space-y-3 lg:hidden">
      {events.map((event) => {
        const shared = isEventShared(event);

        return (
          <article
            key={event.id}
            className="rounded-[1.75rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
          >
            <div className="flex items-start gap-3">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-700 to-sky-600 text-white">
                <FaCalendarAlt />
              </div>

              <div className="min-w-0 flex-1">
                <p className="font-bold text-slate-950 dark:text-white">
                  {getEventTitle(event)}
                </p>

                <p className="mt-1 text-xs font-semibold text-slate-400">
                  {formatDateFr(event.start)}
                </p>

                <p className="mt-2 flex items-center gap-2 text-xs font-bold text-slate-500 dark:text-white/50">
                  <FaMapMarkerAlt className="shrink-0 text-slate-300" />
                  <span className="truncate">{getEventLocation(event)}</span>
                </p>

                <div className="mt-3 flex flex-wrap gap-2">
                  <span
                    className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getEventStatusStyle(
                      event,
                    )}`}
                  >
                    {getEventStatusLabel(event)}
                  </span>

                  <span
                    className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getEventTypeStyle(
                      event,
                    )}`}
                  >
                    {getEventType(event)}
                  </span>

                  {shared && (
                    <span className="inline-flex min-h-8 items-center gap-2 rounded-2xl bg-indigo-100 px-3 text-xs font-bold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200">
                      <FaShareAlt />
                      Partagé
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-4 grid gap-2 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => onOpen(event)}
                className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
              >
                <FaEye />
                Voir l’événement
              </button>

              <button
                type="button"
                onClick={() => onDelete(event.id)}
                className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl border border-red-200 bg-red-50 px-4 py-2 text-xs font-bold text-red-700 transition hover:-translate-y-0.5 hover:bg-red-100 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-200"
              >
                <FaTrash />
                Supprimer
              </button>
            </div>
          </article>
        );
      })}
    </section>
  );
}

export default EventsMobileList;